export const DEFAULT_PLAZA_TELEMETRY_TIMEOUT = 60000;

export const setCurrentChart = (currentChart) => ({
  type: 'SET_CURRENT_CHART',
  currentChart,
});

export const plazaLoaded = (plaza) => ({
  type: 'PLAZA_LOADED',
  plaza,
});

export const setPlazaTopologyNodes = (topologyNodes) => ({
  type: 'SET_PLAZA_TOPOLOGY_NODES',
  payload: topologyNodes,
});

export const setPlazaTelemetryTimeout = (timeout) => ({
  type: 'SET_PLAZA_TELEMETRY_TIMEOUT',
  payload: timeout,
});

export const setUserSettings = (settings) => ({
  type: 'SET_USER_SETTINGS',
  payload: settings,
});

export const setDefaultUserSettings = () => ({
  type: 'SET_DEFAULT_USER_SETTINGS',
});

export const setViewingNodeId = (id) => ({
  type: 'SET_VIEWING_NODE_ID',
  payload: id,
});

export const setViewingNodeData = (data) => ({
  type: 'SET_VIEWING_NODE_DATA',
  payload: data,
});

export const setZoom = (zoom) => ({
  type: 'SET_ZOOM',
  payload: { zoom },
});

export const setMinimapExpanded = (expanded) => ({
  type: 'SET_MINIMAP_EXPANDED',
  payload: { expanded },
});

export const setSchemaParams = (params) => ({
  type: 'SET_SCHEMA_PARAMS',
  payload: { params },
});

export const setAvailableTemplateTypes = templates => ({
  type: 'SET_AVAILABLE_PLAZA_TEMPLATES',
  payload: { templates },
});

export const setMonitorView = (id, view = 'tree') => ({
  type: 'SET_PLAZA_MONITOR_VIEW',
  payload: { id, view },
});

export const resetMonitorView = () => ({
  type: 'RESET_PLAZA_MONITOR_VIEW',
});

export const setMonitorTableViewColumnsConfig = (data) => ({
  type: 'SET_TABLE_VIEW_COLUMNS_CONFIG',
  payload: data,
});
